<template>
  <div class="is-line-left-solid yk-interactions__container__share yyk-interactions__container__share-last-new-s">
    <div class="yk-interactions--header"
         style="padding-right:0;">
      <span class="interaction-tips">测验</span>
      <el-input placeholder="请输入名称查询"
                v-model="paperName"
                @keyup.enter.native='getPaperList'>
        <i slot="suffix"
           class="el-input__icon el-icon-search"
           @click="getPaperList()"></i>
      </el-input>
      <!-- <el-button type="primary"
                 size="small"
                 @click="goback()"
                 class="yk-btn-new yk-btn-new-back-1"
                 icon="wl-icon-fanhui2"></el-button> -->
    </div>
    <div class="yk-class-activity-add-btn-wrapper" 
         @click="openAddPaperDialog()">
      <i class="wl-icon-tianjia1"></i>
      <span style="color:black;">新增测验</span>
    </div>
    <div class="yt-interactions-line-division"></div>
    <div class="yk-interactions--inner"
         v-show="list.length>0">
      <el-table ref="multipleTable"
                :data="list"
                stripe
                tooltip-effect="dark"
                empty-text=" ">
        <el-table-column label="序号"
                         type="index"
                         width="60">
        </el-table-column>
        <el-table-column prop="PaperName"
                         label="测验名称">
        </el-table-column>
        <el-table-column prop="TotalScore"
                         label="总分"
                         width="100">
        </el-table-column>
        <el-table-column prop="CreatorName"
                         label="创建人"
                         width="200">
        </el-table-column>
        <el-table-column label="操作"
                         width="200">
          <template slot-scope="scope">
            <el-button size="mini"
                       @click="openDetails(scope.row.PaperType,scope.row.Id)"
                       icon="el-icon-edit"
                       title="编辑"
                       type="primary"></el-button>
            <el-button size="mini"
                       type="danger"
                       @click="delPaper(scope.row.Id)"
                       icon="el-icon-delete"
                       title="删除"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="noDataShow"
         class="yk-nodata-source-content">
      <img src="~assets/images/the-last-new-nodata-imag.png"
           alt=""
           class="yk-prompt">
      <div class="sp-noData">暂无内容，请新增测验。</div>
    </div>
    <el-pagination background
                   @size-change="handleSizeChange"
                   @current-change="onPageChangeHandler"
                   :current-page="pageIndex"
                   :page-sizes="[5 , 10, 15, 20]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalCount"
                   v-show="totalCount>0">
    </el-pagination>
    <el-dialog class="yk-ccs-dialog"
               title="新增测验"
               :visible.sync="dialogForAddPaper"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form>
        <el-form-item label="测验名称：">
          <el-input auto-complete="off"
                    v-model="addName"
                    style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancelAddPaper()">取 消</el-button>
        <el-button :disabled="disabled"
                   type="primary"
                   @click="sureAddPaper()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="yk-ccs-dialog"
               title="修改测验"
               :visible.sync="editdialogForAddPaper"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <el-form>
        <el-form-item label="测验名称：">
          <el-input auto-complete="off"
                    v-model="editName"
                    style="width:400px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancelAddPaper()">取 消</el-button>
        <el-button :disabled="disabled"
                   type="primary"
                   @click="sureEditPaper()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPaperList,
  DelPaper,
  AddPaper,
  UpdatePaperName
} from 'api/v1.design.paper';
import { verifyPaper } from 'api/v1.manager.schoolactivity';
export default {
  props: {
    schoolCourseId: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    userType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      /** 分页 */
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      /** 查询条件 */
      paperType: '3',
      paperName: '',
      /** 返回列表 */
      list: [],
      /** 新建弹窗 */
      dialogForAddPaper: false,
      editdialogForAddPaper: false,
      editActivityId: '',
      addName: '',
      editName: '',
      /** */
      /* 颜色改变 */
      active: 1,
      disabled: false,
      loadingShow: false,
      noDataShow: false,
      ids: [],
      word: ''
    };
  },
  created() {
    this.getPaperList(1);
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  methods: {
    editActivity(row) {
      this.editActivityId = row.Id;
      this.editName = row.PaperName;
      this.editdialogForAddPaper = true;
    },
    sureEditPaper() {
      UpdatePaperName(this.editActivityId, this.editName).then(rst => {
        if (rst.code > 0) {
          this.$message.success(rst.msg);
          this.editdialogForAddPaper = false;
          this.getPaperList(1);
        } else {
          this.$message.warning(rst.msg);
        }
        this.disabled = false;
      });
    },
    /** 返回列表 */
    getPaperList(page) {
      this.loadingShow = true;
      GetPaperList(this.schoolCourseId, this.courseId, this.paperType, page, this.paperName, this.pageSize).then(
        rst => {
          this.list = rst.list;
          this.loadingShow = false;
          if (this.list.length === 0) {
            this.noDataShow = true;
          } else {
            this.noDataShow = false;
          }
          this.totalCount = rst.pagination.totalCount;
          this.pageSize = rst.pagination.pageSize;
          this.pageIndex = rst.pagination.pageIndex;
        }
      );
    },
    onPageChangeHandler(page) {
      this.getPaperList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPaperList(1);
    },
    /** 新增 */
    openAddPaperDialog() {
      this.dialogForAddPaper = true;
      this.disabled = false;
    },
    sureAddPaper() {
      this.disabled = true;
      AddPaper(this.schoolCourseId, this.courseId, this.paperType, this.addName, this.userType).then(rst => {
        this.$message({ type: 'success', message: rst.msg });
        if (rst.code > 0) {
          this.dialogForAddPaper = false;
          this.addName = '';
          this.getPaperList(this.pageIndex);
          this.openDetails(this.paperType, rst.paperId);
        }
        this.disabled = false;
      });
    },
    cancelAddPaper() {
      this.dialogForAddPaper = false;
      this.editdialogForAddPaper = false;
      this.addName = '';
      this.editName = '';
      this.editActivityId = '';
    },
    /** 删除 */
    delPaper(paperId) {
      this.$confirm('是否删除该测验？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          DelPaper(paperId).then(rst => {
            if (rst.code > 0) {
              this.$message({ type: 'success', message: rst.msg });
              this.getPaperList(this.pageIndex);
            } else {
              this.$message({ type: 'warning', message: rst.msg });
            }
          });
        })
        .catch(() => {});
    },
    /** 详情 */
    openDetails(type, paperId) {
      this.$router.push({
        name: 'teaHomework_bank',
        params: { schoolCourseId: this.courseId, paperId: paperId }
      });
    },
    goto: function(name, params) {
      this.$router.push({ name: name, params: params });
    }
  }
};
</script>

<style lang="scss">
.yk-interactions__container__share {
  .yk-interactions--header {
    .yk-sourse--nemu-btn-wrapper-pre-dis {
      float: right;
      margin-left: 10px;
      width: 90px;
      height: 32px;
      background: rgba(63, 162, 255, 1);
      border-radius: 3px;
      line-height: 32px;
      text-align: center;
      color: #fff;
    }
  }
  .yk-class-activity-add-btn-wrapper {
    padding: 10px;
    margin-top: 20px;
    text-align: center;
    font-size: 17px;
    /* color: #fff; */
    border-radius: 10px;
    border: 1px dashed black;
    cursor: pointer;
    .wl-icon-tianjia1 {
      margin-right: 10px;
      font-size: 25px;
      border-radius: 50%;
      color:black;
      border: 1px solid black;
      vertical-align: -2px;
    }
  }
}
.yyk-interactions__container__share-last-new-s {
  .el-input__inner {
    height: 32px;
  }
  .yk-interactions--header .el-input .el-input__inner{
    height:32px;  
  }
  .yk-btn-new-back-1 {
    position: fixed;
    right: 30px;
    top: 10px;
    z-index: 2000;
    padding: 2px 10px;
    .wl-icon-fanhui2 {
      font-size: 29px;
    }
  }
  .el-pagination__total {
    margin-right: 10px;
    font-weight: 400;
    color: #fff;
  }
  .el-pagination__jump {
    margin-left: 24px;
    font-weight: 400;
    color: #fff;
  }
}
</style>